import { type ReactNode, useEffect } from "react";

import { useClearCacheIfNewVersion } from "@vega-api/custom/api/hooks/useClearCacheIfNewVersion";
import { FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { getVersion } from "@vega-core/utils/appVersion";

export function Root({ children }: { children?: ReactNode }): ReactNode {
  const config = usePublicConfig();
  const appVersion = getVersion();

  const { clearCacheIfNewVersion } = useClearCacheIfNewVersion({
    source: FrontendPortal.LP_PORTAL,
  });

  useEffect(() => {
    if (config.pwa?.icons) {
      const icons = config.pwa.icons;

      // Update apple-touch-icon
      if (icons.appleTouch) {
        let appleTouchLink = document.querySelector(
          'link[rel="apple-touch-icon"]',
        ) as HTMLLinkElement | null;

        if (!appleTouchLink) {
          appleTouchLink = document.createElement("link");
          appleTouchLink.rel = "apple-touch-icon";
          document.head.appendChild(appleTouchLink);
        }
        appleTouchLink.href = icons.appleTouch;
      }
    }
  }, [config]);

  useEffect(() => {
    if (appVersion) clearCacheIfNewVersion(appVersion);
  }, [appVersion, clearCacheIfNewVersion]);

  return children ?? null;
}
